import { Component, OnDestroy, OnInit } from "@angular/core";
import { Library } from "src/app/models/library";
import { ApplicationPool } from "src/app/services/application.pool";
import { trigger, transition, style, animate } from "@angular/animations";
import { ActionService } from "src/app/services/action.service";
import { FormAutomation } from "src/app/form/form-automation";
import { User } from "src/app/models/user";
import { Router } from "@angular/router";
import { Globals } from "src/app/services/globals";
import { environment } from "src/environments/environment";
import { NgSelectConfig } from "@ng-select/ng-select";
import { LoginResponse } from "src/app/models/login-response";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss", "../template/template.component.scss"],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("1s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ height: "45px", opacity: 1 }),
        animate("1s ease-in", style({ opacity: 0 })),
      ]),
    ]),
    trigger("inAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("1s ease-out", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class LoginComponent implements OnInit, OnDestroy {
  public loading: boolean = false;
  public FormAutomation = FormAutomation;

  public credentialsCorrect: boolean = true;

  public login: User & {
    otp: string | null;
    requestEmailPassword: boolean;
    storeOtpHash: boolean;
    otpStore: string | undefined;
    force: boolean | undefined;
  } = new User() as any;
  public requestOtp: boolean = false;
  public repeatOtp: boolean = false;
  public repeatOtpTime: number = 20;

  public get HasLibrary(): boolean {
    return this.login.library == undefined;
  }

  public get IsTesting(): boolean {
    return environment.testing;
  }

  private lastRunSelectedId: number = null;

  public get libraries(): Library[] {
    if (this.dataPool.GeneralLibraries && !this.lastRunSelectedId) {
      this.lastRunSelectedId = Globals.LastSelectedLibraryId;
      if (this.lastRunSelectedId) {
        const libs = this.dataPool.GeneralLibraries.filter(
          (l) => l.id == this.lastRunSelectedId
        );
        if (libs.length > 0 && !this.login.library) {
          this.login.library = libs[0];
        }
      }
    }
    if (this.dataPool.data.User) {
      this.router.navigate(["/"], { replaceUrl: true });
    }
    return this.dataPool.GeneralLibraries;
  }

  get isConnected() {
    return this.dataPool.isConnected;
  }

  private interval: any;
  constructor(
    private dataService: ActionService,
    private dataPool: ApplicationPool,
    private router: Router,
    config: NgSelectConfig
  ) {
    config.bindLabel = "label";
    config.notFoundText = "Kein Ergebnis";
    config.openOnEnter = true;

    this.interval = setInterval(() => {
      if (this.dataPool.isLoading && this.libraries) {
        this.dataPool.getLoadingMap().clear();
      }
    }, 500);
  }
  ngOnDestroy() {
    clearInterval(this.interval);
  }

  ngOnInit() {}

  public async execLogin(force: boolean = false) {
    if (this.login.library)
      Globals.LastSelectedLibraryId = this.login.library.id;
    this.loading = true;
    if (this.IsTesting) this.login.library = new Library(-1, true, "");

    this.login.otpStore = JSON.parse(localStorage.getItem("otpstore") || "[]");

    this.login.force = force;

    this.dataService.login(this.login).then((res: LoginResponse) => {
      if (res.status > 0) {
        this.credentialsCorrect = true;
        this.loading = false;
        if (res.otpStore) {
          localStorage.setItem("otpstore", JSON.stringify(res.otpStore));
        }
        if (res.requestPasswordReset) {
          this.router.navigate(["/login/update"], { replaceUrl: true });
        } else {
          this.router.navigate(["/"], { replaceUrl: true });
        }
      } else if (res.status == LoginResponse.STATUS.REQUEST_OTP) {
        this.credentialsCorrect = !this.requestOtp;
        this.emailPasswordSupported ||= this.login.requestEmailPassword;
        this.login.requestEmailPassword = false;
        (this.login as any).otp = "";
        this.requestOtp = true;
        this.loading = false;
      } else if (res.status == LoginResponse.STATUS.REPEAT_OTP) {
        this.repeatOtp = true;
        this.repeatOtpTime = (res.user as any).validDays;
        (this.login as any).otp = "";
        this.loading = false;
      } else {
        this.loading = false;
        this.credentialsCorrect = false;
      }
    });
  }

  compare(lib1: Library, lib2: Library) {
    if (lib1 && lib2) return lib1.id == lib2.id;
    return lib1 == lib2;
  }

  emailPasswordSupported = false;
  requestEmailPassword() {
    this.login.requestEmailPassword = true;
    this.requestOtp = false;
    this.execLogin().then();
  }
}
